module.exports = __webpack_public_path__ + "static/media/view3.b92ccf38.jpg";